// Phase 2 - NOTTO Format Constants (#27)

// Transplant Types per NOTTO reporting standards
export const TRANSPLANT_TYPES = [
  { name: "Live Donor", value: "1" },
  { name: "Cadaver / Deceased Donor", value: "2" },
  { name: "Swap Transplant", value: "3" },
];

// Crossmatch Results
export const CROSSMATCH_RESULTS = [
  { name: "Negative (Compatible)", value: "negative" },
  { name: "Positive (Incompatible)", value: "positive" },
  { name: "Not Done", value: "not_done" },
];

// NOTTO-compliant cause of brain death codes
export const BRAIN_DEATH_CAUSES = [
  { name: "Traumatic Brain Injury", value: "TBI" },
  { name: "Cerebrovascular Accident (CVA)", value: "CVA" },
  { name: "Hypoxic Brain Injury", value: "HBI" },
  { name: "Brain Tumor", value: "BT" },
  { name: "Other", value: "OTHER" },
];

// NOTTO Report Status
export const NOTTO_REPORT_STATUS = [
  { name: "Draft", value: "1" },
  { name: "Submitted to NOTTO", value: "2" },
  { name: "Acknowledged by NOTTO", value: "3" },
];
